import { useMemo, useState } from "react";

import type { InvitationPersonaModel } from "shared/types";
import { Modal } from "shared/uikit";
import type { ActionModel } from "shared/uikit/BaseDialog";
import { ModalSizesEnum } from "shared/uikit/BaseDialog";

import type { InviteModalContentProps } from "./content";
import InviteModalContent from "./content";

interface InviteModalProps extends Omit<InviteModalContentProps, "onChangeSelected"> {
	modalTitle: string;
	loading?: boolean;
	onClose: (invitations?: Partial<InvitationPersonaModel>[]) => void;
	fullWidth?: boolean;
}

const InviteModal: React.FC<InviteModalProps> = ({ modalTitle, loading, fullWidth, onClose, supportBulk, ...rest }) => {
	const [selected, setSelected] = useState<Partial<InvitationPersonaModel>[]>([]);

	const modalActions: ActionModel[] = useMemo(() => {
		return [
			{
				text: "Send invitations",
				onClick: async () => {
					onClose(selected);
				},
				loading,
				disabled: !selected.length || loading
			}
		];
	}, [onClose, selected, loading]);

	return (
		<Modal
			open
			onClose={onClose}
			title={modalTitle}
			actions={modalActions}
			sizes={supportBulk ? ModalSizesEnum.FULLSCREEN : ModalSizesEnum.LARGE}
			fixedHeightSize={!supportBulk ? ModalSizesEnum.LARGE : undefined}
			fullWidth={fullWidth}
		>
			<InviteModalContent onChangeSelected={setSelected} {...rest} />
		</Modal>
	);
};

export default InviteModal;
